import { render } from "./SubmittedOfferSmall.vue?vue&type=template&id=20204230&scoped=true"
import script from "./SubmittedOfferSmall.vue?vue&type=script&lang=js"
export * from "./SubmittedOfferSmall.vue?vue&type=script&lang=js"

import "./SubmittedOfferSmall.vue?vue&type=style&index=0&id=20204230&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-20204230"

export default script